module.exports = __webpack_public_path__ + "static/img/pay-fail.09a7da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payimg/pay-fail.png
// module id = GfVF
// module chunks = 17